import { __spreadArray } from "tslib";
import { ext, mat3, vec3 } from '@antv/matrix-util';
import { assign } from '@antv/util';
/**
 * Coordinate Base Class
 */
var Coordinate = /** @class */ (function () {
    function Coordinate(cfg) {
        // èªèº«å±æ§
        this.type = 'coordinate';
        this.isRect = false;
        this.isHelix = false;
        this.isPolar = false;
        this.isReflectX = false;
        this.isReflectY = false;
        var start = cfg.start, end = cfg.end, _a = cfg.matrix, matrix = _a === void 0 ? [1, 0, 0, 0, 1, 0, 0, 0, 1] : _a, _b = cfg.isTransposed, isTransposed = _b === void 0 ? false : _b;
        this.start = start;
        this.end = end;
        this.matrix = matrix;
        this.originalMatrix = __spreadArray([], matrix); // å»é¤å¼ç¨
        this.isTransposed = isTransposed;
    }
    /**
     * åå§åæµç¨
     */
    Coordinate.prototype.initial = function () {
        // centerãwidthãheight
        this.center = {
            x: (this.start.x + this.end.x) / 2,
            y: (this.start.y + this.end.y) / 2,
        };
        this.width = Math.abs(this.end.x - this.start.x);
        this.height = Math.abs(this.end.y - this.start.y);
    };
    /**
     * æ´æ°éç½®
     * @param cfg
     */
    Coordinate.prototype.update = function (cfg) {
        assign(this, cfg);
        this.initial();
    };
    Coordinate.prototype.convertDim = function (percent, dim) {
        var _a;
        var _b = this[dim], start = _b.start, end = _b.end;
        // äº¤æ¢
        if (this.isReflect(dim)) {
            _a = [end, start], start = _a[0], end = _a[1];
        }
        return start + percent * (end - start);
    };
    Coordinate.prototype.invertDim = function (value, dim) {
        var _a;
        var _b = this[dim], start = _b.start, end = _b.end;
        // äº¤æ¢
        if (this.isReflect(dim)) {
            _a = [end, start], start = _a[0], end = _a[1];
        }
        return (value - start) / (end - start);
    };
    /**
     * å°åæ ç¹è¿è¡ç©éµåæ¢
     * @param x   å¯¹åº x è½´ç»å¸åæ 
     * @param y   å¯¹åº y è½´ç»å¸åæ 
     * @param tag é»è®¤ä¸º 0ï¼å¯åå¼ 0, 1
     * @return    è¿ååæ¢åçä¸é¶åé [x, y, z]
     */
    Coordinate.prototype.applyMatrix = function (x, y, tag) {
        if (tag === void 0) { tag = 0; }
        var matrix = this.matrix;
        var vector = [x, y, tag];
        vec3.transformMat3(vector, vector, matrix);
        return vector;
    };
    /**
     * å°åæ ç¹è¿è¡ç©éµéåæ¢
     * @param x   å¯¹åº x è½´ç»å¸åæ 
     * @param y   å¯¹åº y è½´ç»å¸åæ 
     * @param tag é»è®¤ä¸º 0ï¼å¯åå¼ 0, 1
     * @return    è¿åç©éµéåæ¢åçä¸é¶åé [x, y, z]
     */
    Coordinate.prototype.invertMatrix = function (x, y, tag) {
        if (tag === void 0) { tag = 0; }
        var matrix = this.matrix;
        var inverted = mat3.invert([0, 0, 0, 0, 0, 0, 0, 0, 0], matrix);
        var vector = [x, y, tag];
        if (inverted) {
            // å¦æä¸ºç©ºåä¸è¿è¡ç©éµååï¼é²æ­¢æ¥é
            vec3.transformMat3(vector, vector, inverted);
        }
        return vector;
    };
    /**
     * å°å½ä¸åçåæ ç¹æ°æ®è½¬æ¢ä¸ºç»å¸åæ ï¼å¹¶æ ¹æ®åæ ç³»å½åç©éµè¿è¡åæ¢
     * @param point å½ä¸åçåæ ç¹
     * @return      è¿åè¿è¡ç©éµåæ¢åçç»å¸åæ 
     */
    Coordinate.prototype.convert = function (point) {
        var _a = this.convertPoint(point), x = _a.x, y = _a.y;
        var vector = this.applyMatrix(x, y, 1);
        return {
            x: vector[0],
            y: vector[1],
        };
    };
    /**
     * å°è¿è¡è¿ç©éµåæ¢ç»å¸åæ è½¬æ¢ä¸ºå½ä¸ååæ 
     * @param point ç»å¸åæ 
     * @return      è¿åå½ä¸åçåæ ç¹
     */
    Coordinate.prototype.invert = function (point) {
        var vector = this.invertMatrix(point.x, point.y, 1);
        return this.invertPoint({
            x: vector[0],
            y: vector[1],
        });
    };
    /**
     * åæ ç³»æè½¬åæ¢
     * @param  radian æè½¬å¼§åº¦
     * @return        è¿ååæ ç³»å¯¹è±¡
     */
    Coordinate.prototype.rotate = function (radian) {
        var matrix = this.matrix;
        var center = this.center;
        ext.leftTranslate(matrix, matrix, [-center.x, -center.y]);
        ext.leftRotate(matrix, matrix, radian);
        ext.leftTranslate(matrix, matrix, [center.x, center.y]);
        return this;
    };
    /**
     * åæ ç³»åå°åæ¢
     * @param dim åå°ç»´åº¦
     * @return    è¿ååæ ç³»å¯¹è±¡
     */
    Coordinate.prototype.reflect = function (dim) {
        if (dim === 'x') {
            this.isReflectX = !this.isReflectX;
        }
        else {
            this.isReflectY = !this.isReflectY;
        }
        return this;
    };
    /**
     * åæ ç³»æ¯ä¾åæ¢
     * @param s1 x æ¹åç¼©æ¾æ¯ä¾
     * @param s2 y æ¹åç¼©æ¾æ¯ä¾
     * @return     è¿ååæ ç³»å¯¹è±¡
     */
    Coordinate.prototype.scale = function (s1, s2) {
        var matrix = this.matrix;
        var center = this.center;
        ext.leftTranslate(matrix, matrix, [-center.x, -center.y]);
        ext.leftScale(matrix, matrix, [s1, s2]);
        ext.leftTranslate(matrix, matrix, [center.x, center.y]);
        return this;
    };
    /**
     * åæ ç³»å¹³ç§»åæ¢
     * @param x x æ¹åå¹³ç§»åç´ 
     * @param y y æ¹åå¹³ç§»åç´ 
     * @return    è¿ååæ ç³»å¯¹è±¡
     */
    Coordinate.prototype.translate = function (x, y) {
        var matrix = this.matrix;
        ext.leftTranslate(matrix, matrix, [x, y]);
        return this;
    };
    /**
     * å°åæ ç³» x y ä¸¤ä¸ªè½´è¿è¡è½¬ç½®
     * @return è¿ååæ ç³»å¯¹è±¡
     */
    Coordinate.prototype.transpose = function () {
        this.isTransposed = !this.isTransposed;
        return this;
    };
    Coordinate.prototype.getCenter = function () {
        return this.center;
    };
    Coordinate.prototype.getWidth = function () {
        return this.width;
    };
    Coordinate.prototype.getHeight = function () {
        return this.height;
    };
    Coordinate.prototype.getRadius = function () {
        return this.radius;
    };
    /**
     * whether has reflect
     * @param dim
     */
    Coordinate.prototype.isReflect = function (dim) {
        return dim === 'x' ? this.isReflectX : this.isReflectY;
    };
    /**
     * éç½® matrix
     * @param matrix å¦æä¼ å¥ï¼åä½¿ç¨ï¼å¦åä½¿ç¨æé å½æ°ä¸­ä¼ å¥çé»è®¤ matrix
     */
    Coordinate.prototype.resetMatrix = function (matrix) {
        // å»é¤å¼ç¨å³ç³»
        this.matrix = matrix ? matrix : __spreadArray([], this.originalMatrix);
    };
    return Coordinate;
}());
export default Coordinate;
//# sourceMappingURL=base.js.map